import { render } from "./FilesUploader.vue?vue&type=template&id=0e3e7fff&ts=true"
import script from "./FilesUploader.vue?vue&type=script&lang=ts"
export * from "./FilesUploader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__